import { Device } from "./device.model";

export class Camera {
  id: string;
  deviceId: string;
  descCam: string;
  orderCam: number;
  name: string;
  miniPicture: string;
  totalPictures: number;
  ipMachine: string

  constructor(ipMachine?: string, deviceId?: string, id?: string, descCam?: string, orderCam?: number, name?: string, miniPicture?: string, totalPictures?: number) {
    this.ipMachine = ipMachine
    this.deviceId = deviceId
    this.id = id;
    this.descCam = descCam;
    this.orderCam = orderCam;
    this.name = name;
    this.miniPicture = miniPicture;
    this.totalPictures = totalPictures;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/camera.ts